import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { index, id, form, submitBtn } = data;
        const fileURL = APP_COMPONENTS.fileForms.getURL(index);
        if (!fileURL) {
            APP_COMPONENTS.fileError.show('INCOMPLETE', 'Please upload an avatar before submitting.');
            return;
        }
        const payload = {
            id,
            name: form.fullname.value.trim(),
            quote: form.quote.value.trim(),
            avatar: fileURL,
            orderIndex: index
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/testimonials/update', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Testimonial updated successfully.`
            });
            APP_COMPONENTS.fileForms.update(index, form, id);
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
